export enum ModalHeaderType {
  INFO = 'info',
  ERROR = 'error',
}
